import { useStore } from "../../app/stores/store";
import DataTable, { DataType } from "../../app/common/DataTable";
import { useEffect } from "react";
import { useMemberStatusOptions } from "../../app/common/enums/memberStatus";
import { useTranslation } from "react-i18next";
import agent from "../../app/api/agent";

export default function UnpaidMemberships() {
  const { t } = useTranslation();
  const { memberStore } = useStore();
  const { loadUnpaidMemberships } = memberStore;
  const memberStatusOptions = useMemberStatusOptions();

  useEffect(() => {
    loadUnpaidMemberships({});
  }, [loadUnpaidMemberships]);

  const options = () => {
    return Array.from(
      { length: new Date().getFullYear() - 2000 + 1 },
      (_, index) => ({ value: 2000 + index, text: 2000 + index })
    );
  };
  const columns = [
    {
      key: "year",
      header: t("unpaidMemberships.columns.year"),
      options: options(),
      dataType: DataType.SELECT,
      filterable: true,
      width: "80px",
      defaultValue: new Date().getFullYear(),
    },
    {
      key: "status",
      header: t("unpaidMemberships.columns.status"),
      options: memberStatusOptions,
      dataType: DataType.SELECT,
      filterable: true,
    },
    {
      key: "firstName",
      header: t("unpaidMemberships.columns.firstName"),
      filterable: true,
    },
    {
      key: "lastName",
      header: t("unpaidMemberships.columns.lastName"),
      filterable: true,
    },
    {
      key: "email",
      header: t("unpaidMemberships.columns.email"),
      filterable: true,
    },
    {
      key: "phone",
      header: t("unpaidMemberships.columns.phone"),
      filterable: true,
    },
    {
      key: "memberShipFee",
      header: t("unpaidMemberships.columns.membershipFee"),
      filterable: false,
      DataType: DataType.NUMBER,
      formatPrice: true,
    },
    {
      key: "unPaidAmount",
      header: t("unpaidMemberships.columns.totalDebt"),
      filterable: false,
      DataType: DataType.NUMBER,
      formatPrice: true,
    },
    {
      key: "paidAmount",
      header: t("unpaidMemberships.columns.totalPaid"),
      filterable: false,
      DataType: DataType.NUMBER,
      formatPrice: true,
    },
  ];

  return <DataTable
    columns={columns}
    data={memberStore.tableData}
    clickUrl={(item) => `/update-member/${item.id}`}
    onFilter={memberStore.loadUnpaidMemberships}
    defaultOrderByColumn="lastName"
    exportAgentMethod={agent.Members.getUnpaidMembershipsXlsxExport} />
}
